import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { CowIcon } from 'src/assets/svg'
import { fileToBase64 } from 'src/utils/file'
import { useUpdateAnimalImage } from 'src/hooks/api/animal'

interface ISelectAnimalImage {
  idAnimal: string
  animalImage: string | null
  farmId: string
  isLoadingAnimalImage: boolean
}

export const SelectAnimalImage = ({ idAnimal, animalImage, farmId, isLoadingAnimalImage }: ISelectAnimalImage) => {
  const [imageUrl, setImageUrl] = useState(animalImage || '')
  const fileInputRef = useRef<HTMLInputElement>(null)
  const classes = useStyles()

  const { mutateAsync: saveAnimalImageMutation, isPending } = useUpdateAnimalImage()

  // =========================
  // CLICK IMAGE
  // =========================
  const handleImageClick = useCallback(() => {
    if (isPending) return
    fileInputRef.current?.click()
  }, [isPending])

  // =========================
  // UPLOAD IMAGE
  // =========================
  const handleFileChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0]
      if (!file) return

      const preview = URL.createObjectURL(file)
      const base64 = await fileToBase64(file)

      await saveAnimalImageMutation({
        farmId,
        animalId: idAnimal,
        imageBase64: base64
      })

      setImageUrl(preview)
    },
    [idAnimal, farmId]
  )

  // =========================
  // SYNC IMAGE
  // =========================
  useEffect(() => {
    if (animalImage) setImageUrl(animalImage)
  }, [animalImage])

  const isLoading = isLoadingAnimalImage || isPending

  // =========================
  // RENDER
  // =========================
  return (
    <Box
      onClick={handleImageClick}
      className={classes.defaultImageContainer}
      style={{ cursor: isLoading ? 'default' : 'pointer' }}
    >
      <Box className={classes.animalImage}>
        {/* LOADING */}
        {isLoading ? (
          <CircularProgress />
        ) : !imageUrl ? (
          /* EMPTY */
          <Box textAlign='center'>
            <CowIcon className={classes.defaultImage} />
            <Typography className={classes.addImageText}>Animal sem imagem</Typography>
          </Box>
        ) : (
          /* IMAGE */
          <img
            src={imageUrl}
            alt='animal'
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 20 }}
          />
        )}
      </Box>

      <input ref={fileInputRef} type='file' hidden onChange={handleFileChange} accept='image/*' />
    </Box>
  )
}
